import React from 'react'

export default function About() {
  return (
    <>
    {/* <h6 className='slides'>About</h6> */}
    <div className='sideBySide'>
    <img className="aboutImg" src='https://avatars.githubusercontent.com/u/101531285?v=4'/>
    <p className='projectDesc'>Hi, I'm Stephen OMarrah, 
      <br/><br/> 
      I am a full stack developer with my focus being on creativity and innovation. I have a background in just about all things art from painting to basic 3D modeling and animations. I have experience working with large and small teams from my past experience working in security.
    </p>
    </div>
    </>
  )
}
